export default "__VITE_ASSET__NOxO_nQm__"